<div class="row">
  <div class="card mb-0">
    <div class="card-header d-flex">
      <h3 class="flex-grow-1">
        {{ datosPaciente?.nombres ?? "" }} {{ datosPaciente?.apellidos ?? "" }}
      </h3>
    </div>

    <div class="card-body">
      <div class="row">
        <!-- Documento -->
        <div class="col-md-12">
          <small>Documento:</small>
          <p>
            <strong>
              {{ datosPaciente?.tDocumento?.tipo ?? "" }}: #
              {{ datosPaciente?.identificacion ?? "" }}
            </strong>
          </p>
        </div>

        <!-- Celular -->
        <div class="col-md-12">
          <small>Celular / Móvil:</small>
          <p>
            <strong>{{ datosPaciente?.celular ?? "" }}</strong>
          </p>
        </div>

        <!-- Email -->
        <div class="col-md-12">
          <small>Email:</small>
          <p>
            <strong>{{ datosPaciente?.email ?? "" }}</strong>
          </p>
        </div>

        <!-- Fecha nacimiento -->
        <div class="col-md-12">
          <small>Fecha nacimiento:</small>
          <p>
            <strong>
              {{ datosPaciente?.fnacimiento | date : "dd/MM/yyyy" : "UTC" }}
            </strong>
          </p>
        </div>

        <!-- Consentimiento informado -->
        <div class="col-md-12">
          <small>Consentimiento informado:</small>
          <p>
            <a class="dropdown-item" href="/consentimiento">
              <i
                class="mdi mdi-file-document text-primary font-size-16 align-middle me-1"
              ></i>
              <span class="align-middle">Ver / Firmar consentimiento</span>
            </a>
          </p>
        </div>

        <!-- Cerrar sesión -->
        <div class="col-md-12">
          <small>Cerrar Sesión:</small>
          <p>
            <a
              class="dropdown-item"
              href="javascript:void(0);"
              (click)="logout()"
            >
              <i
                class="mdi mdi-logout text-muted font-size-16 align-middle me-1"
              ></i>
              <span class="align-middle" key="t-logout">Salir</span>
            </a>
          </p>
        </div>

        <!-- Cerrar cuenta -->
        <div class="col-md-12">
          <small>Cerrar mi cuenta:</small>
          <p>
            <a
              class="dropdown-item text-danger"
              href="javascript:void(0);"
              (click)="cerrarCuenta()"
            >
              <i
                class="mdi mdi-account-remove text-danger font-size-16 align-middle me-1"
              ></i>
              <span class="align-middle">Eliminar permanentemente</span>
            </a>
          </p>
        </div>
      </div>
    </div>

    <small>
      Si encuentras algún dato errado, por favor consulta con la Psicóloga.
    </small>
  </div>
</div>

<!-- Modal: Firmar consentimiento -->
<div
  class="modal fade"
  [class.show]="mostrarModalConsentimiento"
  [style.display]="mostrarModalConsentimiento ? 'block' : 'none'"
  tabindex="-1"
  *ngIf="mostrarModalConsentimiento"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Consentimiento Informado</h5>
        <button
          type="button"
          class="btn-close"
          (click)="cerrarModalConsentimiento()"
        ></button>
      </div>

      <div class="modal-body">
        <h4 class="text-center text-primary mb-4">
          CONSENTIMIENTO INFORMADO PARA TRATAMIENTO PSICOLÓGICO
        </h4>

        <p>
          Yo,
          <strong
            >{{ datosPaciente?.nombres }} {{ datosPaciente?.apellidos }}</strong
          >, identificado(a) con documento
          <strong
            >{{ datosPaciente?.tDocumento?.tipo }}:
            {{ datosPaciente?.identificacion }}</strong
          >, declaro que:
        </p>

        <ol class="mb-4" style="line-height: 2">
          <li>
            He sido informado(a) sobre la naturaleza del tratamiento psicológico
            que voy a recibir.
          </li>
          <li>
            Comprendo que la información compartida durante las sesiones es
            confidencial.
          </li>
          <li>
            Autorizo el tratamiento de mis datos personales según la Ley 1581 de
            2012.
          </li>
          <li>
            Entiendo que puedo suspender el tratamiento en cualquier momento.
          </li>
          <li>
            Los registros de las sesiones serán almacenados de forma segura.
          </li>
          <li>Acepto la modalidad de atención (presencial/virtual).</li>
          <li>
            Me comprometo a asistir puntualmente o cancelar con anticipación.
          </li>
        </ol>

        <div class="form-check p-3 bg-light rounded">
          <input
            class="form-check-input"
            type="checkbox"
            id="aceptoConsentimiento"
            [(ngModel)]="consentimientoAceptado"
          />
          <label class="form-check-label" for="aceptoConsentimiento">
            <strong
              >He leído y acepto los términos del consentimiento
              informado</strong
            >
          </label>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="cerrarModalConsentimiento()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="firmarConsentimiento()"
          [disabled]="!consentimientoAceptado"
        >
          <i class="mdi mdi-pencil me-1"></i>
          Firmar Consentimiento
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del modal -->
<div
  class="modal-backdrop fade"
  [class.show]="mostrarModalConsentimiento"
  *ngIf="mostrarModalConsentimiento"
></div>

<!-- Modal: Consentimiento firmado -->
<div
  class="modal fade"
  [class.show]="mostrarConsentimientoFirmado"
  [style.display]="mostrarConsentimientoFirmado ? 'block' : 'none'"
  tabindex="-1"
  *ngIf="mostrarConsentimientoFirmado"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-success text-white">
        <h5 class="modal-title">
          <i class="mdi mdi-check-circle me-2"></i>
          Consentimiento Firmado
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          (click)="cerrarModalFirmado()"
        ></button>
      </div>
      <div class="modal-body">
        <p>Usted ya ha firmado el consentimiento informado.</p>
        <p>
          <strong>Fecha de firma:</strong>
          {{
            datosPaciente?.fechaConsentimiento
              | date : "dd/MM/yyyy HH:mm" : "UTC"
          }}
        </p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          (click)="cerrarModalFirmado()"
        >
          Entendido
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del modal firmado -->
<div
  class="modal-backdrop fade"
  [class.show]="mostrarConsentimientoFirmado"
  *ngIf="mostrarConsentimientoFirmado"
></div>
